// extracted by mini-css-extract-plugin
export default {"container":"HomeMVS_container__nS0fu"};